<template>
  <div id="index" v-if="x">
    <!--艺人百科-->
    <div class="baike" v-if="actorShow">
      <div class="top">
        <span class="first">艺人百科</span><span class="sec"><router-link to='/baike'>查看更多>></router-link></span>
      </div>
      <div class="imgList">
        <div class="aImg-wrapper">
          <div v-for="item in searchData.actor" :key="item.id" class="aImg-li">
            <router-link :to="{
            name:'Actor',
             params:{
               id:item.id
              }
          }">
              <img :src="item.picture" :alt="item.name" class="aImg">
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!--剧组信息-->
    <div class="crew" v-if="crewShow">
      <div class="top">
        <span class="first">剧组信息</span> <span class="sec"><router-link to='/juzu'>查看更多>></router-link></span>
      </div>
      <div class="crew-wrapper">
        <ul class="crewContent">
          <li v-for="item in searchData.crew" :key="item.id" class="crew-info">
            <router-link style="display: flex" :to="{
              name:'Group',
              params:{
                id:item.id
              }
            }">
              <div class="crew-img-wrapper">
                <img :src="item.picture" class="crew-img">
              </div>
              <div class="introduction">
                <p>影片名称：{{item.movie_name}}</p>
                <p>影片类型：{{item.theme}}</p>
                <p>出品方：{{item.make}}</p>
                <p>筹备地点：{{item.prepare}}</p>
                <p>开机时间：{{item.start_time}}</p>
                <p>暂定拍摄地点：{{item.take_place}}</p>
                <p>作品简介：{{item.synopsis}}</p>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <!--热点观察-->
    <div class="hot-spot" v-if="hotShow">
      <div class="top">
        <span class="first">热点观察</span> <span class="sec"><router-link to='/hot'>查看更多>></router-link></span>
      </div>
      <div class="hot-content">
        <div v-for="item in searchData.essay" :key="item.id" class="hot-wrapper">
          <router-link :to="{
              name:'Hot',
              params:{
                id:item.id
              }
            }">
            <div style="display: flex">
              <div style="width: 30%;height: 30%;"><img :src="item.picture" :alt="item.name" class="hot-img"></div>
              <div class="info">
                <span>{{item.title}}</span>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <!--映派专访-->
    <div class="interview" v-if="yopooShow">
      <div class="top">
        <span class="first">映派专访</span> <span class="sec"><router-link to='/video'>查看更多>></router-link></span>
      </div>
      <div class="inter-content">
        <div v-for="item in searchData.yopoo" :key="item.id" class="inter-wrapper">
          <router-link  :to="{
              name:'Video',
              params:{
                id:item.id
              }
            }">
            <div style="display: flex">
              <div style="width: 30%;height: 30%;"><img  :src="item.picture" :alt="item.name" class="hot-img"></div>

              <div class="info">
                <span>{{item.title}}</span>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import storage from '../storage/storage'
  import store from '../assets/store'
  import bus from '../assets/eventsBus'
  import Vue from 'vue'


  export default {
    data() {
      return {
        searchData: this.$route.query.Data,
        crewShow: true,
        hotShow: true,
        yopooShow: true,
        actorShow: true,
        x:true

      }
    },
    methods: {
      getSearchData(){
        let sData = store.fetch()
        this.searchData = sData
      }

    },

    mounted(){
      // this.getSearchData()
      bus.$on('sendSearchData',()=>{
        store.save(this.$route.query.Data)
        this.getSearchData()


      })
      if (store.fetch().crew.length === 0){
        this.crewShow = false
      }
      if (store.fetch().actor.length === 0){
        this.actorShow = false
      }
      if (store.fetch().yopoo.length === 0){
        this.yopooShow = false
      }
      if (store.fetch().essay.length === 0){
        this.hotShow = false
      }

      window.addEventListener("popstate", ()=>{
        this.$router.push('/')
      }, false);

      window.onload = ()=>{
        this.searchData = store.fetch()
      }

    },
    // watch: {
    //   searchData(newData) {
    //     store.save(newData)
    //     console.log(newData)
    //   },
    //   deep:true
    // }
  }
</script>

<style scoped>
  .baike, .crew, .hot-spot, .interview {
    background: #fff;
    padding: 0 .14rem
  }

  .baike {
    padding: 0 .14rem;
    padding-bottom: .4rem;

  }

  .crew-wrapper {
    padding-bottom: .36rem;
  }

  .hot-spot, .interview {
    margin-top: .20rem;
  }

  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: .4rem 0;
  }

  .first {
    font-size: .25rem; /*rem*/
    font-family: MicrosoftYaHei;
    font-weight: bold;
  }

  .sec {
    font-size: .21rem; /*rem*/
    font-family: MicrosoftYaHei;

  }

  .imgList {

  }

  .aImg-wrapper {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-around;
  }

  .aImg-li {
    width: 3rem;
    margin: .05rem 0;
    padding-left: .16rem;
  }

  .aImg-li:nth-child(1) {
    padding-left: 0;
  }

  .aImg {
    width: 100%;
    height: 100%;

  }

  .indexSlide {
    margin: .20rem 0;

  }

  .crew-img {
    width: 100%;
    height: auto;
  }

  .crew-info {
    display: flex;
  }

  .introduction {
    flex: 1;
    font-size: .23rem; /*no*/
    margin: .52rem .13rem;
    font-family: MicrosoftYaHei;
    font-weight: normal;
  }

  .crew-img-wrapper {
    width: 2.24rem;
  }

  .hot-wrapper, .inter-wrapper{
    margin-top: .3rem;
  }
  .inter-content, .hot-content {
    /*display: flex;*/
  }


  .hot-img {
    width: 100%;
    height: auto;
  }

  .info {
    flex: 1;
    font-size: .3rem; /*rem*/
    overflow: hidden;
    font-family: MicrosoftYaHei;
    font-weight: normal;
    margin-top: .3rem;
    margin-left: .4rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Search.vue